import { ChangeDetectionStrategy, Component, HostBinding, Input, OnDestroy, OnInit, signal, WritableSignal } from '@angular/core';
import { Subscription } from 'rxjs';
import { IonSkeletonText } from '@ionic/angular/standalone';
import { CmsPostPublicSortByEnum } from 'graphql/generated';
import { PostService } from '@app/core/services/post.service';
import { GAnalyticService } from '@app/core/services/g-analytic.service';

@Component({
  standalone: true,
  selector: 'ups-banner',
  styleUrl: './banner.component.scss',
  templateUrl: './banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'w-100 d-flex flex-column'
  },
  imports: [ 
    IonSkeletonText
  ],
})
export class BannerComponent implements OnInit, OnDestroy {

  @HostBinding('class') @Input({ required: true }) public position!: 'side' | 'top' | 'bottom';
  public readonly isShowing: WritableSignal<boolean> = signal(false);
  public readonly data: WritableSignal<{ postTitle: string, urlKey: string, image: string, guid: string }[]> = signal([]);
  protected sub?: Subscription;

  constructor(
    protected readonly ga: GAnalyticService,
    protected readonly postService: PostService
  ) { }

  public ngOnInit(): void{
    if (this.position === 'side' && /Mobi/i.test(window.navigator.userAgent)) return;

    this.isShowing.set(true);
    this.sub = this.postService.query({ pageSize: 5, termName: `BANNER-${ this.position.toUpperCase() }`, sortBy: CmsPostPublicSortByEnum.PublishedAt, sortDirection: 'desc' }).subscribe({
      error: () => {
        this.isShowing.set(false);
      },
      next: ({ data: { cmsMsPostsPublic: { edges }}}) => {
        if (!edges || edges.length === 0) {
          this.isShowing.set(false);
          return;
        }

        this.data.set(
          edges.map(({ node: { postTitle, postExt, urlKey, guid }}: any) => {
            return { postTitle, urlKey, guid, image: postExt.find(({ extType }: any) => extType === 'THUMBNAIL_IMAGE')?.file?.publicUrl };
          })
        );
        this.isShowing.set(true);
      }
    });
  }

  public ngOnDestroy(): void{
    this.sub?.unsubscribe();
  }

  public sendEvent({ postTitle }: any): void{
    this.ga.event({ action: 'banner_click', category: `banner-${ this.position }`, label: postTitle });
  }

  public viewBanner(guid: string, title: string): void{
    this.ga.event({ 
      label: title,
      action: 'banner_view', 
      category: `banner-${ this.position }`
    });
    this.postService.increaseView(guid).subscribe({ next: () => {}});
  }
}
